import { Reveal, SectionLabel, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { DEAL_TERMS } from "@/lib/content";

export default function Deal() {
    return (
        <section
            id="deal"
            className="relative border-t border-white/10 bg-navy-900"
            data-testid="deal"
        >
            <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
                <Reveal>
                    <SectionLabel index="02">The Deal</SectionLabel>
                </Reveal>

                <div className="grid gap-14 md:grid-cols-12">
                    <div className="md:col-span-5">
                        <Reveal delay={0.1}>
                            <h2 className="font-display text-3xl md:text-5xl font-light leading-tight tracking-tight text-white">
                                Private Seed round into HEIR PTE. LTD.
                            </h2>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <p className="mt-8 text-base leading-relaxed text-white/60">
                                The SAFE provides investors with conversion rights
                                at the $10M valuation (or the price of the next
                                equity round, whichever is more favorable, subject
                                to standard SAFE terms).
                            </p>
                        </Reveal>
                    </div>

                    <div className="md:col-span-7">
                        <Reveal delay={0.15}>
                            <div className="border border-white/10">
                                <StaggerGroup stagger={0.07}>
                                    {DEAL_TERMS.map((row, i) => (
                                        <StaggerItem key={row.term}>
                                            <div
                                                className={`group flex items-center justify-between gap-6 px-6 py-5 transition-colors duration-300 hover:bg-white/[0.03] ${
                                                    i !== DEAL_TERMS.length - 1
                                                        ? "border-b border-white/10"
                                                        : ""
                                                }`}
                                            >
                                                <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-white/50">
                                                    {row.term}
                                                </span>
                                                <span className="text-right text-sm md:text-base font-medium text-white">
                                                    {row.detail}
                                                </span>
                                            </div>
                                        </StaggerItem>
                                    ))}
                                </StaggerGroup>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
